module.exports = __webpack_public_path__ + "16129c123f907d2e73e1868887c95c2d.png";